import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    centerContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
    },
    header: {
      padding: 20,
      paddingBottom: 15,
      borderBottomWidth: 1,
    },
    headerBadgeRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12,
    },
    publicBadge: {
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 12,
      flexDirection: 'row',
      alignItems: 'center',
    },
    publicBadgeText: {
      fontSize: 12,
      fontWeight: '600',
      color: '#fff',
    },
    qrButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: 1,
    },
    title: {
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 8,
    },
    description: {
      fontSize: 14,
      marginBottom: 12,
    },
    infoRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 8,
    },
    tournamentTypeRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
    },
    infoText: {
      fontSize: 14,
    },
    statusBadge: {
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 12,
    },
    statusText: {
      fontSize: 12,
      fontWeight: '600',
      textTransform: 'capitalize',
    },
    championBanner: {
      marginTop: 10,
      paddingHorizontal: 10,
      paddingVertical: 6,
      borderRadius: 6,
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: 1,
      alignSelf: 'flex-start',
      marginBottom: 8,
    },
    championLabel: { fontSize: 11, fontWeight: '600', color: '#B8860B', letterSpacing: 0.3 },
    championName: { fontSize: 14, fontWeight: '600' },
    statsRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    participantCount: {
      fontSize: 14,
    },
    followerCount: {
      fontSize: 14,
    },
    followButton: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 14,
      paddingVertical: 8,
      borderRadius: 20,
      borderWidth: 1,
    },
    followButtonText: {
      fontSize: 13,
      fontWeight: '600',
    },

    participantsSection: {
      padding: 20,
    },
    sectionTitle: {
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 15,
    },
    participantItem: {
      padding: 15,
      borderRadius: 10,
      marginBottom: 10,
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: 1,
    },
    seedBadge: {
      color: '#fff',
      paddingHorizontal: 10,
      paddingVertical: 5,
      borderRadius: 12,
      fontWeight: 'bold',
      fontSize: 12,
      marginRight: 12,
    },
    participantDetails: {
      flex: 1,
    },
    participantNameRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    participantName: {
      fontSize: 16,
      fontWeight: '500',
    },
    participantEmail: {
      fontSize: 12,
      marginTop: 2,
    },
    emptyContainer: {
      alignItems: 'center',
      paddingVertical: 60,
    },
    emptyText: {
      fontSize: 16,
      fontWeight: '600',
      marginBottom: 4,
    },

    bottomActions: {
      padding: 15,
      borderTopWidth: 1,
    },
    viewBracketButton: {
      padding: 18,
      borderRadius: 10,
      alignItems: 'center',
    },
    viewBracketButtonText: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    joinButton: {
      padding: 18,
      borderRadius: 10,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: 10,
    },
    joinButtonText: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    joinedBadge: {
      padding: 15,
      borderRadius: 10,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: 10,
    },
    joinedBadgeText: {
      fontSize: 16,
      fontWeight: '600',
    },
    fullBadge: {
      padding: 15,
      borderRadius: 10,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: 10,
    },
    fullBadgeText: {
      fontSize: 16,
      fontWeight: '600',
    },

    errorText: {
      fontSize: 18,
      fontWeight: '600',
      marginBottom: 8,
      textAlign: 'center',
    },
    errorSubtext: {
      fontSize: 14,
      textAlign: 'center',
    },

    rulesSection: {
      margin: 15,
      padding: 15,
      borderRadius: 12,
      borderWidth: 1,
    },
    rulesTitleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginBottom: 12,
    },
    rulesSectionTitle: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    rulesText: {
      fontSize: 14,
      lineHeight: 22,
    },
    eventInfoSection: {
      marginTop: 15,
      paddingTop: 15,
      borderTopWidth: 1,
    },
    eventInfoRow: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: 10,
    },
    eventInfoIcon: {
      marginRight: 12,
      marginTop: 2,
    },
    eventInfoText: {
      flex: 1,
    },
    eventInfoLabel: {
      fontSize: 12,
      marginBottom: 2,
      textTransform: 'uppercase',
      fontWeight: '600',
    },
    eventInfoValue: {
      fontSize: 16,
      fontWeight: '500',
    },
    scrollContent: {
      flex: 1,
    },
  });
